export const api = {
  authApiUrl: import.meta.env.VITE_API_URL
    ? import.meta.env.VITE_API_URL
    : "https://dev-api.konfhub.com",
  apiUrl: import.meta.env.VITE_API_URL
    ? import.meta.env.VITE_API_URL
    : "https://dev-api.konfhub.com",
};
